<template>
  <button
    type="button"
    data-testid="StudentWheelPicker-toggle"
    class="teacher-tool-btn"
    :class="{ selected: studentWheelStore.modalOpen }"
    @click.stop="toggle"
  >
    <v-icon class="teacher-tool-icon">fa-light fa-dharmachakra</v-icon>
    <span class="teacher-tool-label">Izsaukt</span>
  </button>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStudentGroupsStore } from "~/stores/studentGroupsStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"

export default {
  setup() {
    const annotationStore = useAnnotationStore()
    const studentGroupsStore = useStudentGroupsStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { annotationStore, studentGroupsStore, studentWheelStore, timerStore }
  },

  methods: {
    toggle() {
      const opening = !this.studentWheelStore.modalOpen
      if (opening) {
        if (this.annotationStore.annotationMode && this.annotationStore.isGlobal) {
          this.annotationStore.toggleAnnotationMode()
        }
        this.studentGroupsStore.setModalOpen(false)
        this.timerStore.yieldToOtherTool()
      }
      this.studentWheelStore.setModalOpen(opening)
    },
  },
}
</script>
